import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Ignore generic script errors from browser/extensions
    if (error.message === 'Script error.' || 
        error.message === '' ||
        error.name === 'AbortError' ||
        error.name === 'NotAllowedError') {
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore script errors from browser share or extensions
    if (error.message === 'Script error.' || 
        error.message === '' ||
        !error.message ||
        error.name === 'AbortError' ||
        error.name === 'NotAllowedError') {
      // Silently ignore these errors
      this.setState({ hasError: false });
      return;
    }
    
    // Log other real errors
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#020617',
          color: '#06b6d4',
          fontFamily: 'Rajdhani, sans-serif',
          padding: '20px',
          textAlign: 'center'
        }}>
          <div>
            <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</h1>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Une erreur est survenue</h2>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#06b6d4',
                color: '#020617',
                border: 'none',
                padding: '12px 24px',
                fontSize: '1rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
